// extracted by mini-css-extract-plugin
export default {"formContainer":"RegisterPage_formContainer__reVzC","title":"RegisterPage_title__Ncou-","text":"RegisterPage_text__3Pcnq","changeNumberLink":"RegisterPage_changeNumberLink__j7O-c"};